/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, February 21st 2022, 12:52:00 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { SlidingPanel, SlidingPanelProps } from "ui-widgets/transitions/SlidingPanel";

type FixedRightSlidePanelProps = Pick<SlidingPanelProps, "children" | "onClose" | "open">;

export const FixedRightSlidePanel = ({ children, ...props }: FixedRightSlidePanelProps) => {
  return (
    <SlidingPanel {...props} className="os-fixed-right-slide-panel">
      {children}
    </SlidingPanel>
  );
};
